/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Prep_Type_Switch_RecreateInputs */



/**
* | output |
* | --- |
* | "Make the preparation again with this structure" |
*
* @param {Meeting_Prep_Type_Switch_RecreateInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_type_switch_recreate = /** @type {((inputs?: Meeting_Prep_Type_Switch_RecreateInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Type_Switch_RecreateInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Voorbereiding opnieuw maken met deze structuur")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Refaire la préparation avec cette structure")
	return /** @type {LocalizedString} */ ("Make the preparation again with this structure")
});